import { OEAsset, useClient, useItem } from '@adamlip/okeoke.client';
import { Card, CardBody, CardFooter } from '@nextui-org/react';
import OrderItemModalV3 from 'components/Modals/OrderItemModalV3';
import { useContext, useState } from 'react';
import LoadSvg from 'utils/LoadSvg-v3';
import { AppParamsContext } from 'contexts/AppParamsContext';

function ItemCard({ item, showImage }) {
  const { assembledItem } = useItem(item?.itemUUID);
  const { getName } = useClient();
  const { appParams } = useContext(AppParamsContext);
  const [itemModalOpen, setItemModalOpen] = useState(false);

  if (assembledItem?.availability?.visible !== 1 || assembledItem?.enabled !== 1) return null;

  return (
    <>
      <OrderItemModalV3 isOpen={itemModalOpen} setIsOpen={setItemModalOpen} itemUUID={assembledItem?.uuid} readOnly={false} />
      <Card
        style={{
          border: 'var(--button-border-width) solid var(--startNav-category-border-color) ',
        }}
        key={item?.orderItemUUID}
        shadow='sm'
        isPressable
        className='w-auto h-full   bg-[var(--startNav-category-bg-color)] text-[var(--startNav-category-text-color)] rounded-[var(--general-border-radius)]'
        onPress={() => setItemModalOpen(true)}>
        {showImage && (
          <CardBody className='overflow-visible p-0'>
            <div className='h-[110px]'>
              <OEAsset
                uuid={assembledItem?.attributes.appImage}
                addClass={`orderItemListItem-img ${appParams?.features?.imagesContain ? 'img-contain' : 'w-full object-cover h-[110px] w-[150px]'}`}
                size='l'
              />
            </div>
          </CardBody>
        )}

        <CardFooter className='text-small justify-between flex flex-col w-[150px] relative'>
          <p className='text-md w-full text-left'>{getName(item?.name)}</p>
          <p className='w-full text-left'>{parseInt(item.price)} Ft</p>
          <LoadSvg name='plus' />
        </CardFooter>
      </Card>
    </>
  );
}

export default ItemCard;
